// The info tooltips are aligned to the checkbox label, so the callout beak has to be
// pushed back over the info icon it belongs to.
export function beakLeftOverIcon(rowSelector, beakWidth = 16) {
    const row = document.querySelector(rowSelector);
    const label = row && row.querySelector(".ms-Checkbox-text");
    const icon = row && row.querySelector(".ms-TooltipHost");
    if (!label || !icon) {
        return undefined;
    }
    const labelLeft = label.getBoundingClientRect().left;
    const iconRect = icon.getBoundingClientRect();
    return `${Math.round(iconRect.left + iconRect.width / 2 - labelLeft - beakWidth / 2)}px !important`;
}
